// React imports
import { useState } from 'react';

// Generic imports
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

// Mui imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

function AddNewGroup(props) {
    const { org, mode, transportationMethod, offerGroups, setOfferGroups, offers, setOffers, baseRoutes } = props;
    const [ templateSelection, setTemplateSelection ] = useState(null);

    function createOfferGroupFromForm(formId) {
        const form = org.forms[formId];

        const maxgroup = _.max(offerGroups.map(og => {
            if (!og.base?.title?.startsWith('New Group #')) return 0;
            return parseInt(og.base.title.split('#')[1]);
        }));

        const base = {
            title: `New Group #${(maxgroup || 0) + 1}`,
            sections: form.sections.map(s => ({
                id: uuidv4(),
                title: s.title,
                description: s.description,
                offers: [{
                    id: uuidv4(),
                    fields: s.fields.map(f => ({
                        id: f.id,
                        template: f.id,
                        title: f.title,
                        type: f.type,
                        values: {
                            ..._.fromPairs([{id: 'product'}, {id: 'flat'}, {id: 'custom'}, {id: 'date'}].map(p => ([p.id, f.default?.value || f.default?.formula ? f.default : { currency: f.currency || s.defaultCurrency }]))),
                            string: { value: '' }
                        }
                    })),
                }]
            }))
        };

        setOfferGroups([...offerGroups, { id: uuidv4(), base, offers: [] }]);
    }

    function createOfferGroupFromScratch() {
        setOfferGroups([...offerGroups, { id: uuidv4(), base: {
            sections: [{
                id: uuidv4(),
                title: 'New Section',
                offers: [{
                    id: uuidv4(),
                    fields: [{
                        id: uuidv4(),
                        title: 'New Field',
                        type: 'per-unit-type',
                        values: {}
                    }]
                }]
            }]
        }, offers: [] }]);
    }

    return (
        <>
            {!transportationMethod && (
                <Alert severity='info'>
                    Please select a transportation method to start.
                </Alert>
            )}
            <Box sx={{ display: 'inline-flex', alignItems: 'center', mt: 4 }}>
                <FormControl sx={{ width: '350px', mr: 2 }}>
                    <InputLabel id='pick-template-label'>Add a group</InputLabel>
                    <Select
                        labelId='pick-template-label'
                        id='pick-template'
                        label='Add a group'
                        sx={{ flex: 1 }}
                        value={templateSelection || ''}
                        onChange={e => setTemplateSelection(e.target.value)}
                        disabled={!transportationMethod}
                    >
                        {_.map(_.pickBy(org.forms, f => !f.deleted &&
                            ((mode === 'opportunities' && f.type === 'opportunity') || (mode === 'rates' && f.type === 'rate')) &&
                            (!f.transportationMethods || f.transportationMethods.includes(transportationMethod))), (v, k) =>
                        (
                            <MenuItem key={k} value={k}>{v.title}</MenuItem>
                        )
                        )
                        }
                        <Divider />
                        <MenuItem value='scratch'><i>Start from empty template</i></MenuItem>
                    </Select>
                </FormControl>
                <Button
                    disabled={!templateSelection || !transportationMethod}
                    variant='contained'
                    sx={{ textTransform: 'none', whiteSpace: 'nowrap', flex: 1, p: 2 }}
                    onClick={() => templateSelection === 'scratch' ? createOfferGroupFromScratch() : createOfferGroupFromForm(templateSelection)}
                >
                    + Group
                </Button>
            </Box>
        </>
    )
}

export default AddNewGroup;
